// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from './plugins/vuetify'

import messages from "@/settings/locales.js";
import VueI18n from 'vue-i18n'
import { abilitiesPlugin } from '@casl/vue'
import ability from '@/services/ability'
import { Can } from '@casl/vue'
import Loading from '@/components/Loading'
import LoadingDialog from '@/components/LoadingDialog'
import AreYouSure from '@/components/AreYouSure'
import ListTransition from '@/components/ListTransition'
import SaveBeforeLeave from '@/components/SaveBeforeLeave'
import VueQrcodeReader from "vue-qrcode-reader"
import validator from "validator"
import VueKonva from 'vue-konva'
import ImageUploader from 'vue-image-upload-resize'
import settings from "./settings/settings.js"
import VueNoty from 'vuejs-noty'
import service from "@/services/service.js";
import qs from 'qs';
//vuetify switch button does not work great on banner componenet
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

Vue.use(VueNoty, {
	layout: 'bottomRight',
	theme: 'nest',
})


import Hammer from 'hammerjs'

//Hammer is useful for touch gestures


import { store } from './store/store'

import './registerServiceWorker'
//We can now access	 this package with this.$validator
//https://www.npmjs.com/package/validator
Object.defineProperty(Vue.prototype, '$validator', { value: validator })


Vue.use(VueI18n)
Vue.use(VueQrcodeReader)

//Global method
Vue.mixin({
	methods: {
		isUUID(uuid) {
			if (uuid != undefined)
				return validator.isUUID(uuid) && uuid != '00000000-0000-0000-0000-000000000000' && uuid != undefined
			else
				return false
		}
	}
})
//Anwar:creating custom directives
//swipeleft 
//We can use them like so: <tr v-swipeleft:swipeleft="(e)=>deleteMarker(e)"></tr>
//https://vuejs.org/v2/guide/custom-directive.html
//https://codepen.io/lisilinhart/pen/wxRQBo
//https://hammerjs.github.io/recognizer-swipe/

Vue.directive("swipeleft", {
	bind: function (el, binding) {
		if (typeof binding.value === "function") {
			const mc = new Hammer(el);
			mc.get("swipeleft");
			mc.on("swipeleft", binding.value);
		}
	}
});
Vue.directive("swiperight", {
	bind: function (el, binding) {
		if (typeof binding.value === "function") {
			const mc = new Hammer(el);
			mc.get("swiperight");
			mc.on("swiperight", binding.value);
		}
	}
});
//longpress
Vue.directive("press", {
	bind: function (el, binding) {
		if (typeof binding.value === "function") {
			const mc = new Hammer(el);
			mc.get("press").set({ time: 2000 });
			mc.on("press", binding.value);
		}
	}
});

Vue.prototype.$http = service
Vue.prototype.$qs = qs

Vue.component('Can', Can)
Vue.component('loading', Loading)
Vue.component('loadingDialog', LoadingDialog)
Vue.component('areyousure', AreYouSure)
Vue.component('savebeforeleave', SaveBeforeLeave)
Vue.component('list-transition', ListTransition)
Vue.use(VueKonva)
Vue.use(ImageUploader)

Vue.config.productionTip = false
let language = localStorage.getItem("language");
if (!language) language = "EN";
const i18n = new VueI18n({
	locale: language,
	fallbackLocale: 'EN',
	messages,
})
Vue.use(abilitiesPlugin, ability)
/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	vuetify,
	i18n,
	//template: '<App/>',
	render: h => h(App)
	//components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js